import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';

import { buildAutosurCustodyVoucher } from 'lib/pdfs/autosur/valeResguardoAutosur';

export {
  custodyVoucherPreview,
  custodyVoucherFileName,
  isLockedFile,
  locationName,
  scaleStrokes,
  signerName,
} from 'lib/pdfs/autosur/valeResguardoAutosur';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

// Logos are imported on demand, as generateHeaderCajaPopular9Agosto does.
const loadLogos = async () => {
  const [{ LOGO: logoAutosur }, { LOGO: logoSaaf }] = await Promise.all([
    import('lib/pdfs/logoAutosur'),
    import('lib/pdfs/logo'),
  ]);
  return { logoAutosur, logoSaaf };
};

const voucherDoc = async (record, ctx, signature) =>
  buildAutosurCustodyVoucher(record, {
    subcompany: ctx.subcompany && ctx.subcompany.name,
    user: ctx.user,
    ...(await loadLogos()),
    signature,
  });

/**
 * The AUTOSUR voucher of an employee record (one asset from the asset detail,
 * all of them from Reportes > Vales de resguardo), without signature: paper
 * version, downloaded.
 * @param {Object} ctx - {subcompany, user (session user: who hands over)}
 */
export const downloadAutosurCustodyVoucher = async (record, ctx, fileName) =>
  pdfMake.createPdf(await voucherDoc(record, ctx)).download(fileName);

/**
 * The signed voucher as a PDF Blob, for the custody voucher endpoints.
 * @param {Object} signature - {image, signedAt, generatedBy} (lib/vouchers voucherSignature)
 * @returns {Promise<Blob>}
 */
export const autosurCustodyVoucherBlob = async (record, ctx, signature) => {
  const doc = await voucherDoc(record, ctx, signature);
  return new Promise((resolve) => pdfMake.createPdf(doc).getBlob(resolve));
};



// WEBPACK FOOTER //
// src/lib/pdfs/autosur/index.js